import type { IntlShape } from 'react-intl-next';
import uuid from 'uuid';

import { defaultParameters } from '../defaults';
import type { ParseNumber } from '../types';

export const buildChartADF = ({
	adf,
	intl,
	parseNumber,
	sourceId,
}: {
	adf: any;
	intl: IntlShape;
	parseNumber: ParseNumber;
	sourceId: string;
}) => {
	return {
		type: 'extension',
		attrs: {
			extensionType: 'com.atlassian.chart',
			extensionKey: 'chart:default',
			parameters: defaultParameters(adf, intl, parseNumber),
			localId: uuid(),
		},
		marks: [
			{
				type: 'dataConsumer',
				attrs: {
					sources: [sourceId],
				},
			},
		],
	};
};
